var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarsReviews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "92px",
    height: "16px",
    viewBox: "0 0 92 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "starts copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FINAL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INTRO-Copy-33",
    transform: "translate(-1264.000000, -1396.000000)",
    fill: "#4795D6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(1264.000000, 1395.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "starts-copy",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99993229,0 L10.3485193,5.17347479 L16,5.80583096 L11.7999105,9.63573933 L12.9443226,15.1999998 L8,12.3935804 L3.05567718,15.1999998 L4.20008945,9.63573933 L0,5.80583096 L5.65148067,5.17347479 L7.99993229,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999323,0 L29.3485193,5.17347479 L35,5.80583096 L30.7999105,9.63573933 L31.9443226,15.1999998 L27,12.3935804 L22.0556772,15.1999998 L23.2000895,9.63573933 L19,5.80583096 L24.6514807,5.17347479 L26.9999323,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9999323,0 L48.3485193,5.17347479 L54,5.80583096 L49.7999105,9.63573933 L50.9443226,15.1999998 L46,12.3935804 L41.0556772,15.1999998 L42.2000895,9.63573933 L38,5.80583096 L43.6514807,5.17347479 L45.9999323,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9999323,0 L67.3485193,5.17347479 L73,5.80583096 L68.7999105,9.63573933 L69.9443226,15.1999998 L65,12.3935804 L60.0556772,15.1999998 L61.2000895,9.63573933 L57,5.80583096 L62.6514807,5.17347479 L64.9999323,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9999323,0 L86.3485193,5.17347479 L92,5.80583096 L87.7999105,9.63573933 L88.9443226,15.1999998 L84,12.3935804 L79.0556772,15.1999998 L80.2000895,9.63573933 L76,5.80583096 L81.6514807,5.17347479 L83.9999323,0 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarsReviews);
export default __webpack_public_path__ + "static/media/stars-reviews.fd7b89ed2571d64c0b8e920eaa09a09e.svg";
export { ForwardRef as ReactComponent };